import React, {useEffect, useState} from 'react';
import "./AllEventsDays.scss";
import AllEventsApi from "../../../../api/AllEventsApi";
import * as actionCreators from "../../../../store/actions/actions";
import {connect} from "react-redux";
import {
    DAY_NAME,
    DAY_NUMBER,
    MONTH_NUMBER,
    FULL_DATE,
    getCalendarMonth,
    getLabelFromYearAndMonth, getLabelFromYearMonthDay
} from "../../../../tools/formatter";
import moment from "moment";
import DayItem from "../../EventsByDay/DayItem/DayItem";
import UrlManager from "../../../../tools/UrlManager";
import Loading from "../../../../components/Loading/Loading";
import {Grid2} from "@mui/material";

function AllEventsDays(props) {
    const [days, setDays] = useState([]);
    const [labels, setLabels] = useState(null);
    const calendarHeader = [...Array(7).keys()].map(d =>
        <Grid2 key={d} className="DayItemHeader" size={{ xs: 12, sm: 12/7 }} sx={{ display: { xs: 'none', sm: 'block' } }}>{moment().day(d).format(DAY_NAME)}</Grid2>
    );
    const setCurrentNavigationDay = (navigationDay) => {
        props.onUpdateCurrentNavigationDay(navigationDay);
    }


    useEffect(() => {
        setDays([]);
        if ( props.userId && props.currentNavigationYear && props.currentNavigationMonth ) {
            const year = props.currentNavigationYear;
            const month = props.currentNavigationMonth;
            let allDays = getCalendarMonth(year, month);
            allDays = allDays.map(day => {return {'dayDate': day, 'dayInfo': null}});
            AllEventsApi.getByDays(props.userId, year, month).then(response => {
                response.rows.forEach(row => {
                    let key = moment({ year: year, month: month - 1, day: row.eventsDay }).format(FULL_DATE);
                    let index = allDays.findIndex(object => object.dayDate.format(FULL_DATE) === key);
                    if(index > -1) {
                        allDays[index].dayInfo = row;
                    } else {
                        console.log('Cannot find index!', key, allDays);
                    }
                    allDays[key] = row;
                });
                setDays(allDays);
            } ).catch(error => {
                //TODO catch
            });
            AllEventsApi.getLabels(props.userId, 'd', getLabelFromYearAndMonth(props.currentNavigationYear, props.currentNavigationMonth)).then(response => {
                const labelsObject = Object.fromEntries(
                    response.map(item => [item.userdate, { userimage: item.userimage, transform: item.transform ?? null }])
                );
                setLabels(labelsObject);
            } ).catch(error => {
                //TODO catch
            });
        }
    }, [props.userId, props.currentNavigationYear, props.currentNavigationMonth]);

    return props.userId && props.currentNavigationYear && props.currentNavigationMonth ? (
        <div className="AllEventsDays">
            <Grid2 container spacing={1}>
                {days.length > 0 && calendarHeader}
                {days.length > 0 ? days.map((dayObject, index) => {
                    return (
                        <Grid2 
                            sx={{
                                border: parseInt(dayObject.dayDate.format(DAY_NUMBER)) === parseInt(props.currentNavigationDay) &&
                                    parseInt(dayObject.dayDate.format(MONTH_NUMBER)) === parseInt(props.currentNavigationMonth)
                                    ? '2px solid #1976d2'
                                    : ''
                            }} 
                            className={dayObject.dayInfo === null ? 'Empty' : ''} 
                            key={index} 
                            size={{ xs: 12, sm: 12/7 }} 
                            onClick = {() => {
                                const currentNavigationDay = dayObject.dayDate.date().toString();
                                setCurrentNavigationDay(currentNavigationDay);
                                UrlManager.setUrl(props.userId, props.currentNavigationYear, props.currentNavigationMonth, currentNavigationDay);
                            }}
                        >
                            <DayItem 
                                label={labels ? (labels[getLabelFromYearMonthDay(props.currentNavigationYear, props.currentNavigationMonth, dayObject.dayDate.date().toString())] ?? false) : null} 
                                item={dayObject.dayInfo} 
                                itemDate={dayObject.dayDate}
                            />
                        </Grid2>
                    )
                }) : <Loading />}
            </Grid2>
        </div>
    ) : '';
}

const mapStateToProps = state => {
    return {
        currentNavigationYear: state.eventsData.currentNavigationYear,
        currentNavigationMonth: state.eventsData.currentNavigationMonth,
        currentNavigationDay: state.eventsData.currentNavigationDay
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateCurrentNavigationDay: (currentNavigationDay) => dispatch(actionCreators.updateNavigationDay(currentNavigationDay))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllEventsDays);
